<template>
  <div class="e-dialog-layer" v-if="display">
    <div class="e-dialog">
      <h3 class="e-dialog-title">Request Detail</h3>
      <div class="item">
        <div class="item-name">Link</div>
        <e-input v-model="detail.url" disabled class="item-val"></e-input>
      </div>

      <div class="item">
        <div class="item-name">Code</div>
        <e-input v-model="detail.status" disabled class="item-val"></e-input>
      </div>

      <!-- err为空则不显示 -->
      <div class="item" v-if="detail.err">
        <div class="item-name">Error</div>
        <e-input v-model="detail.err" disabled class="item-val"></e-input>
      </div>

      <!-- user_agent为空则不显示 -->
      <div class="item" v-if="detail.user_agent">
        <div class="item-name">UA</div>
        <e-input v-model="detail.user_agent" disabled class="item-val"></e-input>
      </div>

      <!-- header为空则不显示 -->
      <div class="item" v-if="detail.header">
        <div class="item-name">Header</div>
        <e-input v-model="detail.header" disabled class="item-val"></e-input>
      </div>

      <!-- content为空则不显示 -->
      <div class="item" v-if="detail.content">
        <div class="content-box">
          {{ detail.content }}
        </div>
      </div>
      <div>
        <button class="e-dialog-btn" @click="close">Close</button>
      </div>
    </div>
  </div>
</template>

<script>
import EInput from '../components/Input.vue'
export default {
  name: 'e-dialog',
  data() {
    return {
      detail: {},
      display: false,
    }
  },
  methods: {
    close() {
      this.display = false
      this.detail = {}
    },
    show(detail) {
      this.detail = detail
      this.display = true
    },
  },
  components: {
    EInput,
  },
}
</script>

<style scoped>
.e-dialog-layer {
  position: fixed;
  background: rgba(0, 0, 0, 0.65);
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}

.e-dialog {
  position: absolute;
  padding: 20px;
  left: 50%;
  top: 40%;
  transform: translateX(-50%) translateY(-50%);
  width: 40%;
  min-width: 500px;
  height: auto;
  background: #fff;
  border-radius: 10px;
}

.e-dialog-title {
  margin-top: 10px;
  margin-bottom: 10px;
  text-align: center;
}

.e-dialog-btn {
  color: #fff;
  font-size: 14px;
  min-width: 66px;
  padding: 0 14px;
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  flex-wrap: nowrap;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  font-weight: 400;
  outline: 0;
  border: none;
  cursor: pointer;
  width: 128px;
  height: 32px;
  background: #0080cc;
  border-radius: 16px;
}

.item {
  display: flex;
  align-items: right;
  margin: 10px;
}

.item-name {
  margin-right: 10px;
  padding: 0 14px;
  height: 32px;
  line-height: 32px;
  width: 80px;
  text-align: center;
  border: 1px solid #e1e4eb;
  border-radius: 16px;
  color: #909399;
}

.item-val {
  width: 84%;
  text-align: left;
}

.content-box {
  border: 1px solid #e1e4eb;
  padding: 5px;
  margin: auto;
  font-size: 15px;
  height: 200px;
  overflow: scroll;
  text-align: left;
}
</style>
